import _ from 'lodash';
import Vue from 'vue';
import Promise from 'bluebird';
import jQuery from 'jquery';
import * as VueGoogleMaps from 'vue2-google-maps';
import VueMasonry from 'vue-masonry-css';
import 'bootstrap-datetimepicker-npm';

window._ = _;
window.lodash = _;
window.Vue = Vue;
window.Promise = Promise;

Vue.use(VueMasonry);

window.mountVueComponent = (id, component) => {
    var root = document.getElementById(id);
    if (root) {
        var data = null;
        var config = null;

        try {
            var content = root.textContent;
            content = JSON.parse(content);
            data = content.data || null;
            config = content.config || null;

        } catch (e) {
            console.info(`Problem parsing data and config for component ${id}`);
        }

        Vue.use(VueGoogleMaps, {
            load: {
                key: window.env.GOOGLE_MAP_KEY,
                libraries: "places" // necessary for places input
            }
        });

        new Vue({
            el: root,
            render: h => h(component, {
                props: { initialData: data, config }
            }),
        })
    }
}

window.dispatchEvent(new window.CustomEvent('vue-init'));

_.chain(document.querySelectorAll('script[data-src]'))
    .map((el) => {
        el.src = el.dataset.src;
    })
    .value();


// WEBPACK FOOTER //
// ./resources/assets/site/js/vue-init.js